
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.469 20.08a.75.75 0 001.062-1.06l-1.062 1.06zm-4.938-7.076a.75.75 0 00-1.062 1.059l1.062-1.06zm.719-4.484c0 3.464-2.8 6.269-6.25 6.269v1.5c4.282 0 7.75-3.48 7.75-7.77h-1.5zM8 14.789c-3.45 0-6.25-2.805-6.25-6.27H.25c0 4.29 3.468 7.77 7.75 7.77v-1.5zm-6.25-6.27C1.75 5.056 4.55 2.25 8 2.25V.75C3.718.75.25 4.23.25 8.52h1.5zM8 2.25c3.45 0 6.25 2.805 6.25 6.27h1.5C15.75 4.23 12.282.75 8 .75v1.5zm11.531 16.77l-6-6.016-1.062 1.059 6 6.017 1.062-1.06z"}})])
          )
        }
      }
    